import de from "./de";
import it from "./it";
import en from "./en";

export type CmsLocale = "de" | "it" | "en";

export const CMS_LOCALES: { code: CmsLocale; label: string; flag: string }[] = [
  { code: "de", label: "Deutsch", flag: "\u{1F1E9}\u{1F1EA}" },
  { code: "it", label: "Italiano", flag: "\u{1F1EE}\u{1F1F9}" },
  { code: "en", label: "English", flag: "\u{1F1EC}\u{1F1E7}" },
];

const dictionaries: Record<CmsLocale, Record<string, string>> = { de, it, en };

/**
 * Get a translation string. Supports {placeholder} interpolation.
 * Falls back to German, then to the key itself.
 */
export function translate(locale: CmsLocale, key: string, params?: Record<string, string | number>): string {
  let text = dictionaries[locale]?.[key] ?? dictionaries.de[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      text = text.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
    }
  }
  return text;
}
